import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function SimonJackson() {
  const simonJacksonSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Simon Jackson",
    "jobTitle": "Chief Information Officer",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/simon-jackson"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Simon Jackson - Chief Information Officer"
        description="Simon Jackson brings 15 years of technology leadership experience, including 7 years in senior roles spanning banking technology, consulting, and business advisory."
        keywords={['Simon Jackson', 'CIO', 'Technology Leadership', 'Digital Transformation', 'Strategic Planning']}
        ogImage="/SimonJackson.webp"
        schema={simonJacksonSchema}
      />

      <div className="page-width px-20 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[3.8rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Simon Jackson</span>
          </div>
        </nav>

        <div className="flex flex-col gap-4 md:gap-16 pt-24">
          <div className="text-[3.8rem] md:text-[4.8rem] font-bold leading-[4.2rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Simon Jackson
          </div>
          <div className="text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Chief Information Officer
          </div>
        </div>
      </div>

      <div className="pt-[130px] xl:pt-[90px] xl:pb-[80px] page-width">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/SimonJackson.webp" 
                alt="Simon Jackson, Chief Information Officer: Technology Leader in Digital Transformation and Strategic Planning" 
                className="w-full" 
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="text-[2rem] leading-[3.6rem] tracking-[0.8px] font-normal text-left text-white">
                Simon Jackson brings 15 years of technology leadership experience, with 7 years in senior roles across banking technology, technology consulting, and business advisory services. He has built a reputation as a strategic, customer-focused leader who aligns technology initiatives with core business objectives.

                <br /><br />

                Simon has successfully led technology portfolios exceeding $30M and managed cross-functional teams of up to 120 people across multiple countries. His expertise spans strategic technology planning, digital transformation, team leadership, and delivering practical solutions that drive business growth.

                <br /><br />

                He studied a Bachelor of Information Technology and Commerce at the Australian National University and has held professional certifications in AWS, Azure, and Akamai.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="simon-jackson" 
        basePath="/leadership" 
      />
    </div>
  );
}